import React from "react";
import { FaLinkedin } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { CiPhone } from "react-icons/ci";
import { IoMailOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { footerData } from "../../../utils/staticData";
import { handleNavigate } from "../../../utils/commonHelper";
import { Discord, logicalIcon, webLogoWhite } from "../../../assets";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer_section">
      <div className="footer">
        <div className="custom_container footer_container">
          <div className="logo">
            <div className="footer-txt">
              <Link to="#">
                <img
                  // src={logicalIcon}
                  src={webLogoWhite}
                  alt="Logo"
                  onClick={() => handleNavigate("/", "#home", navigate)}
                />
              </Link>

              <p>
                A social media platform designed for meaningful connections and
                conversations between passionate people!
              </p>
              <div className="contact-info">
                <p>
                  <CiPhone className="footer-icons call" />
                  &nbsp; +1 905 490 1212
                </p>
                <p
                  onClick={() =>
                    (window.location.href = "mailto:support@logicalchat.com")
                  }
                >
                  <IoMailOutline className="footer-icons id" />
                  &nbsp; support@logicalchat.com
                </p>
              </div>
            </div>
          </div>

          <div className="links">
            <h3>Usefull links</h3>
            <ul>
              {footerData?.map((data, ind) => (
                <li key={ind}>
                  <Link
                    to="#"
                    id={ind}
                    onClick={() => handleNavigate("/", data?.id, navigate)}
                  >
                    {data?.name}
                  </Link>
                </li>
              ))}
                <li>
                <Link to="/contact-us">Contact us</Link>
              </li>
            </ul>
          </div>

          <div className="links">
            <h3>Legal</h3>
            <ul>
              {/* <li>
                <Link to="/login">Support</Link>
              </li> */}
              <li>
                <Link to="/terms">Terms & conditions</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
            </ul>
          </div>

          {/* <div className="links">
                        <div className="social-icons">
                            <Link to={"https://www.linkedin.com/company/desieconomist"} target="_blank" rel="noopener noreferrer">
                                <FaLinkedin className="footer-icons" />
                            </Link>
                            <Link to={"https://www.facebook.com/groups/455523176836875"} target="_blank" rel="noopener noreferrer">
                                <FaFacebook className="footer-icons" />
                            </Link>
                            <Link to={"https://x.com/_DesiEconomist"} target="_blank" rel="noopener noreferrer">
                                <FaXTwitter className="footer-icons" />
                            </Link>
                            <Link to={"https://www.instagram.com/desi_economist/"} target="_blank" rel="noopener noreferrer">
                                <FaInstagram className="footer-icons" />
                            </Link>
                            <Link to={"https://www.youtube.com/@desieconomist"} target="_blank" rel="noopener noreferrer">
                                <FaYoutube className="footer-icons" />
                            </Link>
                            <Link to={"https://discord.com/channels/1075822663760613468/1075822663760613471"}
                                target="_blank" rel="noopener noreferrer"
                            >
                                <img src={Discord} className="footer-icons discord" />
                            </Link>
                        </div>
                    </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
